export default __webpack_public_path__ + "static/media/dont-get-lost-in-the-cloud.1e6cacf1.jpg";